/**
 * When adding new values here, please remember to update any of the methods/types below as well as:
 * - packages/bureau/bite.json
 * - packages/maitred/src/script/deploy.ts
 * - packages/maitred/src/script/set_env_vars.ts
 * - packages/node-service/src/middleware/session_setup.js
 * OR anywhere else where we use process.env.APP_ENV
 * OR anywhere Environment.STAGING is mentioned
 * OR anywhere that uses a type Environment[]
 */
enum Environment {
  DEV = 'dev',
  PROD = 'prod',
  STAGING = 'staging',
  SANDBOX = 'sandbox',
  TEST = 'test',
}

export { Environment };
